import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewContainerRef
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkshopJob } from 'src/app/models/workshop-job';
import { ViewWorkshopJobStoreService } from '../../view-workshop-job-store.service';
import { EditSiteVisitDialogComponent } from './edit-site-visit-dialog/edit-site-visit-dialog.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmDialogComponent } from 'src/app/shared';
import { MomentModule } from 'ngx-moment';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton, MatButton } from '@angular/material/button';

@Component({
    selector: 'app-site-visit',
    templateUrl: './site-visit.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatIconButton, MatTooltip, MatIcon, MatButton, MomentModule]
})
export class SiteVisitComponent {
  @Input() job: WorkshopJob<any>;
  dateFormat = ConfigService.dates.longDateTimeFormat;

  constructor(
    private store: ViewWorkshopJobStoreService,
    private dialog: MatDialog,
    private vcr: ViewContainerRef
  ) {}

  openInGoogleMaps(location: string, placeId: string | null) {
    const address = location.replace('\n', ' ');
    if (placeId) {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${address}&query_place_id=${placeId}`,
        '_blank'
      );
      return;
    }
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${address}`,
      '_blank'
    );
  }

  openSiteVisitDialog() {
    this.dialog.open(EditSiteVisitDialogComponent, {
      viewContainerRef: this.vcr,
      data: this.job
    });
  }

  confirmClearSiteVisit() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Cancel Site Visit',
          message: 'Are you sure you want to cancel this site visit?'
        }
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.store.updateJob({
            site_place_id: null,
            site_visit_address: null,
            site_visit_date: null
          });
        }
      });
  }
}
